export default __webpack_public_path__ + "static/media/lifong03.2fd015db.png";